$(document).ready(function(){
	// Control opening tabs
	$('.CompositeField.fieldgroup > label.left').click(function(){
		open_tab($(this).parent());
	})

	add_on_change_functions();

	// Triggered when form is submitted
	$('#Form_CalcoolatorForm').submit(function(e){
		e.preventDefault();
		send();
	})

	// Run when form is started
	init();
});

/**
 * When opening the page, some dropdowns should be triggeres, and some fields should be hidden.
 */
function init() {
	// Open first tab
	open_tab_by_position(0);

	// Trigger change on some dropdowns
	var trigger_selectors = '#Form_CalcoolatorForm_ambient_temperature, #Form_CalcoolatorForm_cabinet_temperature, #Form_CalcoolatorForm_application_area, #Form_CalcoolatorForm_device, #Form_CalcoolatorForm_units';
	$(trigger_selectors).trigger('change');

	// Some fields should be hidden by default
	hide_temperature_coefficient_field();
	hide_water_temperature_field();
	hide_elevation_field();
	hide_heat_or_dehumidify_field();
	hide_humidity_fields();
	hide_solar_load_field();

	// Activate/deactivate submit button according to the agreement checkbox
	agreement_checkbox();

	var form = $('#Form_CalcoolatorForm').attr('action');
	form = form.replace('CalcoolatorForm', 'enquiryForm');
	$.ajax({
		url    : form,
		method : 'GET',
		success: function(data) {
			$('#Sendenquiry .middleColumn').html(data);
		},
		error: function(jqXHR, textStatus, errorThrown) {
			console.log('enquiryForm Error');
			console.log(jqXHR);
			console.log(textStatus);
			console.log(errorThrown);
		}
	});
}

function open_tab_by_position(position) {
	// Get tab by the given position
	var tab = $('.CompositeField.fieldgroup:eq(' + position + ')');

	// Call open tab
	open_tab(tab);
}

function open_tab(tab) {
	// Close other tabs
	$('.CompositeField.fieldgroup.opened').removeClass('opened');

	// Open tab
  $(tab).addClass('opened');
}

/**
 * Send form.
 */
function send() {
	// Show loading spinner
	$('#Form_CalcoolatorForm_action_do_calculation').addClass('loading');

	// Send form via ajax
  var form = $('#Form_CalcoolatorForm').attr('action');
	form = form.replace('CalcoolatorForm', 'do_calculation');
	$.ajax({
		url    : form,
		cache  : false,
		method : 'POST',
		data   : $('#Form_CalcoolatorForm').serialize() + '&action_do_calculation=Calculate',
		success: function(data) {
			$('#Form_CalcoolatorForm_action_do_calculation').removeClass('loading');
			$('#Results .middleColumn').html(data);
			$('.fieldgroup.opened').removeClass('opened');
			$('#Results').addClass('opened').show();
			$('#Sendenquiry').show();
			$('input[name="enquiry_results"]').val($('#results-data').val());
		},
		error: function(jqXHR, textStatus, errorThrown) {
			console.log('deu erro');
			console.log(jqXHR);
			console.log(textStatus);
			console.log(errorThrown);
		}
	});
}

function add_on_change_functions() {
	var trigger_selectors = '#Form_CalcoolatorForm_ambient_temperature, #Form_CalcoolatorForm_cabinet_temperature, #Form_CalcoolatorForm_application_area, #Form_CalcoolatorForm_device';

	$('body').on('change', trigger_selectors, function(){
		var disable_array = [];

		var ambient = $('#Form_CalcoolatorForm_ambient_temperature').val();
		var cabinet = $('#Form_CalcoolatorForm_cabinet_temperature').val();
		var not_cooling = ambient <= cabinet;

		var application_value = $('#Form_CalcoolatorForm_application_area').val();
		var device_value = $('#Form_CalcoolatorForm_device ').val();
		var heat_disable_device = $('#Form_CalcoolatorForm').attr('data-heat-disable-device');
		if (heat_disable_device) {
			heat_disable_device = heat_disable_device.split('|');
		}

		var disable_data = [
			['data-application-disable-device', application_value],
			['data-application-disable-mounting', application_value],
			['data-device-disable-mounting', device_value]
		];

		disable_data.forEach(function(item){
			var data = $('#Form_CalcoolatorForm').attr(item[0]);

			if (!data) return;

			data = JSON.parse(data);

			if (!data) return;

			var value = item[1];

			if(!data[value]) return;

			data[value].forEach(function(id){
				disable_array.push(id.toString());
			});
		});

		if (not_cooling) {
			disable_array = disable_array.concat(heat_disable_device);
		}

		$('#Form_CalcoolatorForm_device option, #Form_CalcoolatorForm_mounting option').each(function() {
			var $this = $(this);
			var value = $this.val().toString();
			var disable = disable_array.includes(value);
			if(disable){
				if($this.parent().val() == value){
					$this.parent().val($this.siblings().not('[disabled]').first().val());
				}
				$this.attr('disabled', 'disabled');
			} else {
				$this.removeAttr('disabled');
			}
		});

    force19rack();
	});

	$('#Form_CalcoolatorForm_agreement_Holder-checkbox').change(function(){
		agreement_checkbox();
	})

	// Change labels when units field is changed
	$('#Form_CalcoolatorForm_units').change(function(){
		control_units_label(); // AKA l_rech
	});

	// Show/Hide fields according to Application Area
	$('#Form_CalcoolatorForm_application_area').change(function(){
		control_solar_load_field();
    force19rack();
	})

	// Show/hide fields according to Product Type
	$('#Form_CalcoolatorForm_device').change(function(){
		control_device();
		control_heat_or_dehumidify_field();
	})

	// Control Heat Transfer Coefficient field when Cabinet Housing Material field is changed
	$('#Form_CalcoolatorForm_material').change(function(){
		define_heat_transfer_coefficient(); // AKA ma_wechsel
	});

	// Control Humidity fields when Heating/Dehumidifying is changed
	$('#Form_CalcoolatorForm_heat_or_dehumidify_heating, #Form_CalcoolatorForm_heat_or_dehumidify_entfeuchten').change(function(){
		control_heat_or_dehumidify_field();
	})
}

function agreement_checkbox() {
	if ($('#Form_CalcoolatorForm_agreement_Holder-checkbox').is(':checked')) {
		$('#Form_CalcoolatorForm_action_do_calculation').removeAttr('disabled');
	} else {
		$('#Form_CalcoolatorForm_action_do_calculation').attr('disabled','disabled');
	}
}

/**
 * Re-set fields Metric labels (inch/millimeter and feet/meters), based on the
 * option selected on the Units of length field.
 */
function control_units_label() { // AKA l_rech
	var value = $('#Form_CalcoolatorForm_units').val();

	// Get unit labels, based on the value sent (inch/millimeter)
	var metric_labels = get_metric_labels(value);

	// Height, Width and Depth right title
	$('#Form_CalcoolatorForm_height_Holder .right').text(metric_labels.inch_millimiter);
	$('#Form_CalcoolatorForm_width_Holder .right').text(metric_labels.inch_millimiter);
	$('#Form_CalcoolatorForm_depth_Holder .right').text(metric_labels.inch_millimiter);

	// Redefine Ambient temperature, Cabinet temperature and Water temperature right title
	$('#Form_CalcoolatorForm_ambient_temperature_Holder .right').text(metric_labels.temperature);
	$('#Form_CalcoolatorForm_cabinet_temperature_Holder .right').text(metric_labels.temperature);
	$('#Form_CalcoolatorForm_water_temperature_Holder .right').text(metric_labels.temperature);

	// Height above sea level right title
	$('#Form_CalcoolatorForm_elevation_Holder .right').text(metric_labels.feet_meter);
}

function control_device() {
	var value = $('#Form_CalcoolatorForm_device').val();

	switch (value) {
		case 'cooling': // Cooling unit
		case 'luft-luft': // Air/air heat exchanger
		case 'thermo': // Thermoelectric cooling units
			// Hide all extra fields
			hide_water_temperature_field();
			hide_elevation_field();
			hide_heat_or_dehumidify_field();
			hide_humidity_fields();
			break;
		case 'luft-wasser': // Air/water heat exchanger
			// Hide all extra fields but show water temperature
			show_water_temperature_field();
			hide_elevation_field();
			hide_heat_or_dehumidify_field();
			hide_humidity_fields();
			break;
		case 'heizung': // Enclosure Heater
			// Hide all extra fields but show heating/dehumidifying
			hide_water_temperature_field();
			hide_elevation_field();
			show_heat_or_dehumidify_field();
			hide_humidity_fields();
			break;
		case 'filter': // Filter fans
			// Hide all extra fields but show height above sea level
			hide_water_temperature_field();
			show_elevation_field();
			hide_heat_or_dehumidify_field();
			hide_humidity_fields();
			break;
	}
}

/**
 * Controls Heat Transfer Coefficient field.
 * Triggered by Cabinet housing material dropdown.
 */
function define_heat_transfer_coefficient() { // AKA ma_wechsel
	var value = $('#Form_CalcoolatorForm_material').val();

	if (value == '0') {
		// If value is 0, user can define the coefficient
		$('#Form_CalcoolatorForm_temperature_coefficient').attr('disabled', false).val('');
		$('#Form_CalcoolatorForm_temperature_coefficient_Holder').show();
	} else {
		// Otherwise, coefficient will be defined by the chosen material
		$('#Form_CalcoolatorForm_temperature_coefficient').attr('disabled', true).val(value);
		$('#Form_CalcoolatorForm_temperature_coefficient_Holder').hide();
	}
}

/**
 * Depending on the Application Area option is chosen, enable/disable Additional Solar Load field.
 */
function control_solar_load_field() {
	// If "Outdoor" is set as Application Area
	if ($('#Form_CalcoolatorForm_application_area').val() == 'outdoor') {
		// Enable Additional solar load field
		show_solar_load_field();
	} else {
		// Set Additional solar load value as 0 and disable it
		hide_solar_load_field();
	}
}

/**
 * Depending on the Application Area option is chosen, force 19 rack option.
 */
 function force19rack() {
	if ($('#Form_CalcoolatorForm_application_area').val() == '19') {
		$('#Form_CalcoolatorForm_mounting').val('19_rack');
    $('#Form_CalcoolatorForm_mounting').find(':not(:selected)').prop('disabled', true);
	} else {
		$('#Form_CalcoolatorForm_mounting').find(':not(:selected)').prop('disabled',false);
	}
}

/**
 * Show and enable Water Temperature field.
 */
function show_water_temperature_field() {
	// Enable Water Temperature field
	$('#Form_CalcoolatorForm_water_temperature').attr('disabled', false);

	// Show Water Temperature field
	$('#Form_CalcoolatorForm_water_temperature_Holder').show();
}

/**
 * Reset, hide and disable Temperature Coefficient field.
 */
function hide_temperature_coefficient_field() {
	// Set Temperature Coefficient as Enclosure value
	$('#Form_CalcoolatorForm_temperature_coefficient').val($('#Form_CalcoolatorForm_material').val());

	// Disable Temperature Coefficient field
	$('#Form_CalcoolatorForm_temperature_coefficient').attr('disabled', true);

	// Hide Temperature Coefficient field
	$('#Form_CalcoolatorForm_temperature_coefficient_Holder').hide();
}

/**
 * Reset, hide and disable Water Temperature field.
 */
function hide_water_temperature_field() {
	// Set Water Temperature as 0
	$('#Form_CalcoolatorForm_water_temperature').val('0');

	// Disable Water Temperature field
	$('#Form_CalcoolatorForm_water_temperature').attr('disabled', true);

	// Hide Water Temperature field
	$('#Form_CalcoolatorForm_water_temperature_Holder').hide();
}

/**
 * Show and enable Height Above Sea Level field.
 */
function show_elevation_field() {
	// Enable Height Above Sea Level field
	$('#Form_CalcoolatorForm_elevation').attr('disabled', false);

	// Show Height Above Sea Level field
	$('#Form_CalcoolatorForm_elevation_Holder').show();
}

/**
 * Reset, hide and disable Height Above Sea Level field.
 */
function hide_elevation_field() {
	// Set Height Above Sea Level value as 0
	$('#Form_CalcoolatorForm_elevation').val('0');

	// Disable Height Above Sea Level field
	$('#Form_CalcoolatorForm_elevation').attr('disabled', true);

	// Hide Height Above Sea Level field
	$('#Form_CalcoolatorForm_elevation_Holder').hide();
}

/**
 * Show and enable Additional Solar Load field.
 */
function show_solar_load_field() {
	// Enable Additional Solar Load field
	$('#Form_CalcoolatorForm_solar_load').attr('disabled', false);

	// Show Additional Solar Load field
	$('#Form_CalcoolatorForm_solar_load_Holder').show();
}

/**
 * Reset, hide and disable Additional Solar Load field.
 */
function hide_solar_load_field() {
	// Set Height Above Sea Level value as 0
	$('#Form_CalcoolatorForm_solar_load').val('0');

	// Disable Additional Solar Load field
	$('#Form_CalcoolatorForm_solar_load').attr('disabled', true);

	// Hide Additional Solar Load field
	$('#Form_CalcoolatorForm_solar_load_Holder').hide();
}

/**
 * Control Heating / Dehumidifying field, based on Cabinet and Ambient Temperature difference.
 */
function control_heat_or_dehumidify_field() {
	// Enclosure Heater + Dehumidifying
	if ($('#Form_CalcoolatorForm_device').val() === 'heizung' && $('input[name=heat_or_dehumidify]:checked').val() === 'entfeuchten') {
		show_humidity_fields();
	} else {
		hide_humidity_fields();
	}
}

/**
 * Show Heating / Dehumidifying field.
 */
function show_heat_or_dehumidify_field() {
	// Show Heating / Dehumidifying field
	$('#Form_CalcoolatorForm_heat_or_dehumidify_Holder').show();
}

/**
 * Hide Heating / Dehumidifying field
 */
function hide_heat_or_dehumidify_field() {
	// Hide Heating / Dehumidifying field
	$('#Form_CalcoolatorForm_heat_or_dehumidify_Holder').hide();
}

/**
 * Show Humidity-related fields.
 */
function show_humidity_fields() {
	// Show Highest ambient humidity field
	$('#Form_CalcoolatorForm_air_max_Holder').show();

	// Show Desired maximum cabinet humidity field
	$('#Form_CalcoolatorForm_air_required_Holder').show();

	// Show helper message
	$('#Form_CalcoolatorForm_step4-append').show();
}

/**
 * Hide Humidity-related fields.
 */
function hide_humidity_fields() {
	// Hide Highest ambient humidity field
	$('#Form_CalcoolatorForm_air_max_Holder').hide();

	// Hide Desired maximum cabinet humidity field
	$('#Form_CalcoolatorForm_air_required_Holder').hide();

	// Set Highest ambient humidity value as 0
	$('#Form_CalcoolatorForm_air_max').val('0');

	// Set Desired maximum cabinet humidity value as 0
	$('#Form_CalcoolatorForm_air_required').val('0');

	// Hide helper message
	$('#Form_CalcoolatorForm_step4-append').hide();
}

/**
 * Define which metric labels we should use
 */
function get_metric_labels(unit) {
	var labels = {
		inch_millimiter: '',
		feet_meter:      '',
		temperature:     '',
	};

	switch (unit) {
		case 'imperial':
			labels.inch_millimiter = ss.i18n._t('CALCOOLATOR.Inch');
			labels.feet_meter      = ss.i18n._t('CALCOOLATOR.Feet');
			labels.temperature     = ss.i18n._t('CALCOOLATOR.Fahrenheit_abbr');
			break;

		case 'metric':
			labels.inch_millimiter = ss.i18n._t('CALCOOLATOR.Millimeter_abbr');
			labels.feet_meter      = ss.i18n._t('CALCOOLATOR.Meter');
			labels.temperature     = ss.i18n._t('CALCOOLATOR.Celsius_abbr');
			break;
	}

	return labels;
}



// WEBPACK FOOTER //
// ./assets/js/calcoolator.js